export function controlThumbVideo( trigger, action = 'pause' ) {
  if ( !trigger ) return;
  
  const parent = trigger.parentElement;
  const isVideoThumb = parent?.classList.contains( 'e-vid--pause-on-popup' );
  
  if ( isVideoThumb ) {
    const thumbVideo = parent.querySelector( 'video' );
    if ( thumbVideo ) {
      if ( action === 'pause' ) {
        thumbVideo.pause();
      } else if ( action === 'play' ) {
        thumbVideo.play();
      }
    }
  }
}
  